<template>
  <div class="flex flex-col justify-center items-center content-center">
    <h1 v-if="error.statusCode === 404" class="mt-12 text-5xl">
      {{ $t('errorPage.notFound') }}
    </h1>
    <h1 v-else class="mt-12 text-4xl">
      {{ $t('errorPage.errorOccured') }}
    </h1>
    <NuxtLink :to="$localePath('/')" class="mt-6 text-shade2">
      {{ $t('errorPage.goHome') }}
    </NuxtLink>
  </div>
</template>

<script>
export default {
  layout: 'default',
  props: ['error']
};
</script>
